<template>
  <div class="my-gurus-layout">
    <div class="tabs">
      <div class="left" :class="activeTab === 'mg_promo' ? 'active' : ''" @click="changeTab('mg_promo')">
        <p id="promoP">Guru Promo</p>
      </div>
      <div class="right" :class="activeTab === 'mg_coreset' ? 'active' : ''" @click="changeTab('mg_coreset')">
        <p id="coreSetP">Guru Core Set</p>
      </div>
    </div>

    <div class="contents">
      <MgGurus v-if="activeTab === 'mg_promo'" />
      <MgCoreSet v-if="activeTab === 'mg_coreset'" />
    </div>
  </div>
</template>

<script>
  import MgGurus from './MgGurus';
  import MgCoreSet from './MgCoreSet';

  export default {
    name: 'MyGurus',
    components: {
      MgGurus,
      MgCoreSet
    },
    data: () => ({
      activeTab: 'mg_promo',
    }),
    mounted() {
      this.initialize();
    },
    methods: {
      initialize() {
        if (localStorage.getItem('mgActiveSubTab') === null || localStorage.getItem('mgActiveSubTab') === undefined) {
          localStorage.setItem('mgActiveSubTab', 'mg_promo');
        }
        if (localStorage.getItem('mgActiveSubTab') === 'mg_promo') {
          this.activeTab = 'mg_promo';
        } else {
          this.activeTab = 'mg_coreset';
        }
      },
      changeTab(pTab) {
        this.activeTab = pTab;
        localStorage.setItem('mgActiveSubTab', pTab);
      },
    },
    computed: {
    },
  };
</script>

<style scoped>
  .my-gurus-layout p {
    margin: 0px;
  }

  .tabs {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .tabs .active {
    background-color: #13aff0;
  }
  .tabs .left, .tabs .right {
    padding: 15px 30px;
    color: #fff;
    font-weight: 600;
    font-family: Architects Daughter;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/MyGurus/index.vue